import { createAction } from 'redux-act'

export const payPalExpressStart = createAction('set paypal express start')
export const payPalExpressSuccess = createAction<any>('set paypal express success')
export const payPalExpressFail = createAction<any>('set paypal express fail')
